import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";

import "./style.scss";

export const CustomSelect = ({
  label = "",
  name = "",
  value = "",
  options = [],
  onChange,
  onFocus,
  onBlur,
  size = "small",
  errorMsg = "",
  infoText = "",
  disabled = false,
  hasError = false,
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  const handleFocus = (e) => {
    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <FormControl
      fullWidth
      sx={{ mt: 2 }}
      disabled={disabled}
      error={hasError}
      className="custom-select-wrapper"
    >
      <InputLabel id="simple-select-label" size={size}>
        {label}
      </InputLabel>
      <Select
        labelId="simple-select-label"
        id="simple-select"
        size={size}
        name={name}
        value={value}
        label={label}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      >
        {options.map((option, index) => (
          <MenuItem
            key={`${option.value}-${index}`}
            value={option.value}
            className="select-menu-item"
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {!!infoText && <FormHelperText>{infoText}</FormHelperText>}
      {!!errorMsg && <FormHelperText>{errorMsg}</FormHelperText>}
    </FormControl>
  );
};
